import { Pipe } from '@angular/core';
import { Utils } from '../utils';

@Pipe({name: 'format'})
export class FormatPipe {
    transform(value: string, args: any) {
        return Utils.formatString(String(value), args);
    }
}
